export default class TriageStart {
    geslacht : string;
    leeftijd: number;
    leeftijdEenheid: string;
    triageType: number;
}

